import axiosPost from "./axiosPost";

export const RNESRubrosGet = async (credentials, data) => {
    const body = {
        service: "RNESRubroGet",
        params: {
            rnesRubroId: data?.rubroId || null,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
